






















import { Vue, Component, Prop } from 'vue-property-decorator';
import { DealroomHelper } from '@/dealroom/helpers/dealroom.helper';
import { MAX_FILES, SIZE_LIMIT } from '@signing-page/attachments/constants/upload-attachment';
import { allAcceptedFileTypes } from '@/common/accepted-file-types';

@Component
export default class UploadFileButton extends Vue {
  @Prop() fileName: string;
  @Prop({ default: () => allAcceptedFileTypes }) acceptedFileTypes: string[];
  @Prop({ default: MAX_FILES }) maxNumberOfFiles: number;
  @Prop({ default: SIZE_LIMIT }) sizeLimit: number;

  activeFileHover = false;
  warningMessage: any = null;

  get uploadTitle(): string {
    if (this.warningMessage) {
      return this.warningMessage;
    }
    if (this.fileName) {
      return this.fileName;
    }
    return this.$t('click-or-drop-files-here-to-upload').toString();
  }

  resetWarningMessage() {
    this.warningMessage = null;
  }

  resetInputField() {
    this.resetWarningMessage();
    const inputElement: HTMLInputElement = this.$refs.input as HTMLInputElement;
    inputElement.value = '';
  }

  handleDrop(files: File[]) {
    const file: File = files[0];
    const fileType: string = DealroomHelper.extractFileType(file.name);
    if (DealroomHelper.validFileType(fileType)) {
      this.handleChange(files);
    } else {
      this.warningMessage = this.$t('file-format-not-supported');
    }
    this.activeFileHover = false;
  }

  handleDragOver(elementId: string) {
    if (elementId === 'upload-file-button') {
      this.activeFileHover = true;
    }
  }

  handleDragLeave(elementId: string) {
    if (elementId === 'upload-file-button') {
      this.activeFileHover = false;
    }
  }

  handleChange(files: File[]) {
    this.resetWarningMessage();
    const file: File = files[0];
    if (!file) {
      return;
    }
    if (files.length > this.maxNumberOfFiles) {
      this.warningMessage = this.$t('one-file-at-a-time');
      return;
    }
    if (file.size > this.sizeLimit) {
      this.warningMessage = this.$t('file-is-over-size-limit');
      return;
    }
    this.$emit('selectFile', file);
  }
}
